import { MaterialService } from './material.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { Router } from '@angular/router';
import { KiwixiGlobals } from '../kiwixi/kiwixi.globals';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { RatingStudent } from '../model/rating-student.model';
import { Formation } from '../model/formation.model';

@Injectable()
export class RateStudentService extends KiwixiService {
  apiRatingStudents = environment.server + 'rating_students/';

  constructor(
    private _http: HttpClient,
    private _router: Router,
    kiwixiGlobals: KiwixiGlobals,
    private materialService: MaterialService,
  ) {
    super(_http, _router, kiwixiGlobals, materialService);
  }

  getRatingStudents(params: HttpParams): Observable<RatingStudent[]> {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get<RatingStudent[]>(this.apiRatingStudents, {
      headers: header,
      params: params,
    }).
      pipe(
        catchError(this.handleErrorObservable<RatingStudent[]>(`getRatingStudentsByParams`))
      );
  }

  getRatingStudentsByUrl(url): Observable<RatingStudent[]> {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get<RatingStudent[]>(url, {
      headers: header,
    }).
      pipe(
        catchError(this.handleErrorObservable<RatingStudent[]>(`getRatingStudentsByURL`))
      );
  }

  getRatingStudent(id): Observable<RatingStudent> {
    const header = this.createHttpClientAuthorizationHeader();
    const _urlRatingStudent = this.apiRatingStudents + id + '/';
    return this._http.get<RatingStudent>(_urlRatingStudent, { headers: header }).
      pipe(
        catchError(this.handleErrorObservable<RatingStudent>(`getRatingStudentByID`))
      );
  }

  postRatingStudent(body) {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.post<RatingStudent>(this.apiRatingStudents, body, {
      headers: header
    }).pipe(
      catchError(this.handleErrorObservable<RatingStudent>(`Envoi de RatingStudent`))
    );
  }

  deleteRatingStudent(rateUrl): Promise<RatingStudent> {
    const headers = this.createHttpClientAuthorizationHeader();
    return this._http.delete(rateUrl, { headers: headers })
      .toPromise()
      .then((res: any) => res)
  }

  patchRatingStudent(ratingStudentUrl, param): Promise<RatingStudent> {
    const headers = this.createHttpClientAuthorizationHeader();
    return this._http.patch(ratingStudentUrl, param, { headers: headers })
      .toPromise()
      .then((res: any) => res)
      .catch(err => {
        this.materialService.openSnackBar(`La mise à jour a échouée`, 'red');
      })
  }

  getLastReport(formation: Formation) {
    if (formation) {
      let params = new HttpParams();
      params = params.append('status', 'completed');
      params = params.append('session__formation__student', formation.student.id.toString());
      params = params.append('session__formation__language', formation.language_detail.id.toString());
      params = params.append('ordering', '-session__occurrence__start');
      params = params.append('page_size', '1');
      return this.getRatingStudents(params);
    }
  }

  selfReportedLevelToCecrl(level: string) {
    switch (level) {
      case '1':
        return 'A1';
        break;
      case '2':
        return 'A2';
        break;
      case '3':
        return 'B1';
        break;
      case '4':
        return 'B2';
        break;
      case '5':
        return 'C1';
        break;
      default:
        return 'A1';
        break;
    }
  }

  selfReportedLevelToRatingStudent(level: string) {
    const cecrlLevel = this.selfReportedLevelToCecrl(level)
    const rate = new RatingStudent()
    rate.level_grammar = cecrlLevel,
      rate.grammar = 0;
    rate.level_accent = cecrlLevel;
    rate.accent = 0;
    rate.level_expression = cecrlLevel;
    rate.expression = 0;
    rate.level_comprehension = cecrlLevel;
    rate.comprehension = 0;
    rate.level_vocabulary = cecrlLevel;
    rate.vocabulary = 0;
    rate.level_oral = cecrlLevel;
    rate.level_written = cecrlLevel;
    return rate;
  }
}
